<div id="adv" #advSearchContainer> <!-- Advance search pop up issue -->
  <form id="advSearchForm" [formGroup]="advSearchForm" class="advance-search" (ngSubmit)="submitSearch(advSearchForm.value)">
    <div class="enhanced-search-body">
      <div>
        <!-- Main criteria layout -->
        <div class="enhanced-search w-100 mb-3">
          <!-- Row: Keywords -->
          <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
            <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-keywords">Keywords:</label>
            <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
              <input type="text"
                     pInputText
                     id="adv-search-keywords"
                     class="w-100"
                     formControlName="content"
                     variant="filled"
                     style="width: 100%;"
                     placeholder="Type here">
            </div>
          </div>

          <!-- Divider -->
          <div class="d-flex flex-row flex-nowrap w-100 mb-3">
            <div class="mobile-view-flex2 adv-search-row-label pe-0">
              <div class="adv-search-divider"></div>
            </div>
            <div class="w-100 mobile-view-flex3 ps-0 adv-search-control-col">
              <div class="adv-search-divider adv-search-divider-input"></div>
            </div>
          </div>

          <!-- Row: Search In -->
          <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
            <span id="adv-search-search-in-label" class="mobile-view-flex2 adv-search-row-label">Search In:</span>
            <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
              <p-dropdown inputId="adv-search-search-in"
                          [options]="searchInScopeOptions"
                          formControlName="searchInScope"
                          optionLabel="label"
                          optionValue="value"
                          [appendTo]="'body'"
                          [baseZIndex]="99999"
                          panelStyleClass="adv-search-dropdown-panel"
                          placeholder="Select"
                          styleClass="adv-search-select adv-search-select-full"
                          [attr.aria-labelledby]="'adv-search-search-in-label'">
              </p-dropdown>
            </div>
          </div>

          <!-- Row: To / From / Cc -->
          <div class="w-100 mb-3">
            <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
              <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-to">To:</label>
              <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                <input type="text"
                       id="adv-search-to"
                       pInputText
                       formControlName="to"
                       class="w-100"
                       variant="filled"
                       style="width: 100%;"
                       placeholder="Type here">
              </div>
            </div>
            <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
              <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-from">From:</label>
              <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                <input type="text"
                       id="adv-search-from"
                       pInputText
                       formControlName="from"
                       class="w-100"
                       variant="filled"
                       style="width: 100%;"
                       placeholder="Type here">
              </div>
            </div>
            <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
              <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-cc">Cc:</label>
              <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                <input type="text"
                       id="adv-search-cc"
                       pInputText
                       formControlName="cc"
                       class="w-100"
                       variant="filled"
                       style="width: 100%;"
                       placeholder="Type here">
              </div>
            </div>
          </div>

          <!-- Row: Subject -->
          <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
            <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-subject">Subject:</label>
            <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
              <input type="text"
                     pInputText
                     id="adv-search-subject"
                     class="w-100"
                     formControlName="subject"
                     variant="filled"
                     style="width: 100%;"
                     placeholder="Type here">
            </div>
          </div>

          <!-- Row: Date + custom range -->
          <div class="w-100 mb-3">
            <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
              <span id="adv-search-date-preset-label" class="mobile-view-flex2 adv-search-row-label">Date:</span>
              <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                <!-- scrollHeight: PrimeNG default is 200px (inline on .p-dropdown-items-wrapper); raise so short lists don't scroll -->
                <p-dropdown inputId="adv-search-date-preset"
                            [attr.aria-labelledby]="'adv-search-date-preset-label'"
                            [options]="datePresetOptions"
                            formControlName="datePreset"
                            optionLabel="label"
                            optionValue="value"
                            [appendTo]="'body'"
                            [baseZIndex]="99999"
                            [scrollHeight]="'280px'"
                            panelStyleClass="adv-search-dropdown-panel adv-search-date-preset-panel"
                            (onChange)="onDatePresetChange($event.value)"
                            placeholder="Select"
                            styleClass="adv-search-select adv-search-select-full">
                </p-dropdown>
              </div>
            </div>

            <div class="d-flex flex-row flex-nowrap align-items-center w-100"
                 *ngIf="advSearchForm.get('datePreset')?.value === 'CUSTOM_RANGE'">
              <span id="adv-search-custom-range-label" class="mobile-view-flex2 adv-search-row-label">Custom Range:</span>
              <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col adv-search-custom-range-row">
                <p-calendar inputId="adv-search-start-dt"
                            [attr.aria-labelledby]="'adv-search-custom-range-label'"
                            dateFormat="mm/dd/yy"
                            formControlName="startDt"
                            [maxDate]="maxSelectableDate"
                            [showOtherMonths]="true"
                            [hideOnDateTimeSelect]="true"
                            [selectOtherMonths]="false"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            [yearRange]="'2010:2030'"
                            [styleClass]="'advance-calendar'"
                            [appendTo]="isSmallViewport ? null : 'body'"
                            [panelStyleClass]="'adv-search-datepicker-panel'"
                            [showIcon]="false"
                            [showButtonBar]="true"
                            (onSelect)="startDateSelect()"
                            placeholder="MM/DD/YYYY">
                </p-calendar>
                <p-calendar inputId="adv-search-end-dt"
                            dateFormat="mm/dd/yy"
                            formControlName="endDt"
                            [maxDate]="maxSelectableDate"
                            [showOtherMonths]="true"
                            [hideOnDateTimeSelect]="true"
                            [selectOtherMonths]="false"
                            [readonlyInput]="false"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            [yearRange]="'2010:2030'"
                            [styleClass]="'advance-calendar2'"
                            [appendTo]="isSmallViewport ? null : 'body'"
                            [panelStyleClass]="'adv-search-datepicker-panel'"
                            [showIcon]="false"
                            [showButtonBar]="true"
                            (onSelect)="endDateSelect()"
                            placeholder="MM/DD/YYYY"
                            [ariaLabel]="'End date'">
                </p-calendar>
              </div>
            </div>
          </div>

          <div class="w-100">
            <div
              *ngIf="error.isError"
              class="d-flex flex-row flex-nowrap justify-content-end text-danger error-calender"
            >
              <img src="assets/newMessage/error.svg" class="error" alt="Error" />
              <span>{{ error.errorMessage }}</span>
            </div>
          </div>

          <!-- Row: Attachments toggle -->
          <div class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
            <span id="adv-search-attachment-label" class="mobile-view-flex2 adv-search-row-label">Attachments:</span>
            <div class="ps-2 adv-search-control-col">
              <p-inputSwitch inputId="adv-search-attachment"
                             [attr.aria-labelledby]="'adv-search-attachment-label'"
                             [styleClass]="'advance-inputSwitch'"
                             formControlName="attachment"></p-inputSwitch>
            </div>
          </div>

          <!-- Added filters (from Add filters dropdown) -->
          <ng-container *ngFor="let filterKey of selectedEnhancedFilterKeys">
            <ng-container [ngSwitch]="filterKey">
              <!-- File Name -->
              <div *ngSwitchCase="'FILE_NAME'" class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
                <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-file-name">File Name:</label>
                <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                  <input type="text"
                         pInputText
                         id="adv-search-file-name"
                         class="w-100"
                         formControlName="filename"
                         variant="filled"
                         style="width: 100%;"
                         placeholder="Type here">
                </div>
              </div>

              <!-- Size -->
              <div *ngSwitchCase="'SIZE'" class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
                <span id="adv-search-size-label" class="mobile-view-flex2 adv-search-row-label">Size:</span>
                <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col adv-search-size-row">
                  <p-dropdown inputId="adv-search-size-comp"
                              [options]="sizeComparatorOptions"
                              formControlName="sizeComparator"
                              optionLabel="label"
                              optionValue="value"
                              [appendTo]="'body'"
                              [baseZIndex]="99999"
                              panelStyleClass="adv-search-dropdown-panel"
                              placeholder="Select"
                              styleClass="adv-search-select adv-search-size-comp"
                              [attr.aria-labelledby]="'adv-search-size-label'">
                  </p-dropdown>
                  <input type="number"
                         pInputText
                         id="adv-search-size-value"
                         class="adv-search-size-value"
                         formControlName="sizeValue"
                         variant="filled"
                         min="0"
                         step="any"
                         inputmode="decimal"
                         placeholder="Value"
                         (keydown)="onSizeValueKeydown($event)"
                         (blur)="onSizeValueBlur()">
                  <p-dropdown inputId="adv-search-size-unit"
                              [options]="sizeUnitOptions"
                              formControlName="sizeUnit"
                              optionLabel="label"
                              optionValue="value"
                              [appendTo]="'body'"
                              [baseZIndex]="99999"
                              panelStyleClass="adv-search-dropdown-panel"
                              placeholder="MB"
                              styleClass="adv-search-select adv-search-size-unit">
                  </p-dropdown>
                </div>
              </div>

              <!-- Tag -->
              <div *ngSwitchCase="'TAG'" class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
                <label class="mobile-view-flex2 adv-search-row-label" for="adv-search-tag">Tag:</label>
                <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                  <input type="text"
                         pInputText
                         id="adv-search-tag"
                         class="w-100"
                         formControlName="tag"
                         variant="filled"
                         style="width: 100%;"
                         placeholder="Type here">
                </div>
              </div>

              <!-- Client Category -->
              <div *ngSwitchCase="'CLIENT_CATEGORY'" class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
                <span id="adv-search-client-category-label" class="mobile-view-flex2 adv-search-row-label">Client Category:</span>
                <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                  <p-dropdown inputId="adv-search-client-category"
                              [options]="clientCategoryOptions"
                              formControlName="clientCategory"
                              optionLabel="label"
                              optionValue="value"
                              [appendTo]="'body'"
                              [baseZIndex]="99999"
                              panelStyleClass="adv-search-dropdown-panel"
                              placeholder="Select"
                              styleClass="adv-search-select adv-search-select-full"
                              [attr.aria-labelledby]="'adv-search-client-category-label'">
                  </p-dropdown>
                </div>
              </div>

              <!-- Status -->
              <div *ngSwitchCase="'STATUS'" class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
                <span id="adv-search-status-label" class="mobile-view-flex2 adv-search-row-label">Status:</span>
                <div class="w-100 ps-2 mobile-view-flex3 adv-search-control-col">
                  <p-dropdown inputId="adv-search-status"
                              [options]="statusOptions"
                              formControlName="status"
                              optionLabel="label"
                              optionValue="value"
                              [appendTo]="'body'"
                              [baseZIndex]="99999"
                              panelStyleClass="adv-search-dropdown-panel"
                              placeholder="Select"
                              styleClass="adv-search-select adv-search-select-full"
                              [attr.aria-labelledby]="'adv-search-status-label'">
                  </p-dropdown>
                </div>
              </div>

              <!-- Search in Snoozed -->
              <div *ngSwitchCase="'SEARCH_IN_SNOOZED'" class="d-flex flex-row flex-nowrap align-items-center w-100 mb-3">
                <span id="adv-search-snoozed-label" class="mobile-view-flex2 adv-search-row-label">Search in Snoozed:</span>
                <div class="ps-2 adv-search-control-col">
                  <p-inputSwitch inputId="adv-search-snoozed"
                                 [attr.aria-labelledby]="'adv-search-snoozed-label'"
                                 [styleClass]="'advance-inputSwitch'"
                                 formControlName="searchInSnoozed"></p-inputSwitch>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <div *ngIf="advSearchError" class="mt-4 pt-2 d-flex flex-row flex-nowrap align-items-center invalid-feedback">
            <div class="d-flex flex-row flex-nowrap align-items-center">
              <img src="assets/newMessage/error.svg" class="error" alt="Error" style="margin-right: 8px;">
              <span>Please select valid search criteria</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row flex-nowrap align-items-center justify-content-between enhanced-search-buttons-container">
      <div class="enhanced-search-add-filters">
        <div class="adv-add-filters-wrap">
          <button type="button"
                  class="btn adv-add-filters-btn"
                  (click)="toggleAddFilterMenu($event, $event.currentTarget)"
                  [disabled]="areAllAddFiltersSelected"
                  aria-haspopup="menu"
                  [attr.aria-expanded]="isAddFiltersOpen">
            <span class="adv-add-filters-icon" aria-hidden="true">+</span>
            <span>Add filters</span>
          </button>

          <p-overlayPanel
            #addFiltersOverlay
            [appendTo]="'body'"
            [style]="{ width: '175px', minWidth: '175px', maxWidth: '175px' }"
            [autoZIndex]="false"
            [baseZIndex]="110000"
            [dismissable]="true"
            [styleClass]="'adv-add-filters-panel'"
            (onShow)="isAddFiltersOpen = true"
            (onHide)="isAddFiltersOpen = false">
            <button
              type="button"
              class="adv-add-filter-item"
              *ngFor="let opt of addFilterOptions"
              [disabled]="isAddFilterSelected(opt.key)"
              (click)="onAddFilterOptionClick($event, opt.key)">
              {{ opt.label }}
            </button>
          </p-overlayPanel>
        </div>
      </div>

      <div class="enhanced-search-actions">
        <button type="button" class="btn clear-btn" (click)='clearSearch()'>Reset</button>
        <button type="submit" class="btn search-btn" [disabled]="isApplyDisabled">Apply</button>
      </div>
    </div>
  </form>
</div>
